import AutoNumeric from "autonumeric";
import Vue from 'vue/dist/vue.esm'

$(function () {
  // $(".subscription-add-payment-info")
  //   // .data("association-insertion-method", 'append')
  //   // .data("association-insertion-node", function (link) {
  //   //   return link.closest('form').find('.subscription-operation-fields .subscription-payment')
  //   // })
  //   .on('click', function (e) {
  //     if ($(".subscription-payment-nested-card").length > 0) {
  //       e.preventDefault()
  //       e.stopPropagation()
  //     }
  //   });

  const $addSubscriptionDataButton = $(".add_subscription_data")
  $addSubscriptionDataButton.click(() => {
    const el = $addSubscriptionDataButton.closest("form").find("input[type=submit]")
    el.show()
  })

  $("#subscription_organization_id").select2({
    ajax: {
      url: '/curators/organizations',
      data: function (params) {
        return {
          query: params.term
        }
      },
      dataType: 'json',
      delay: 500,
      processResults: function (data, params) {
        return {
          results: data.data.map(el => {
            return {
              text: `${el.attributes.name} (${el.attributes.user_name})`,
              id: el.id
            }
          })
        }
      },
      cache: true
    }
  })

  $(".customer-subscription-search-query-select").select2({
    ajax: {
      url: '/curators/organizations',
      data: function (params) {
        return {
          query: params.term
        }
      },
      dataType: 'json',
      delay: 500,
      processResults: function (data, params) {
        return {
          results: data.data.map(el => {
            return {
              text: el.attributes.name,
              id: el.attributes.name
            }
          })
        }
      },
      cache: true
    }
  }).on('change', function () {
    $(this).closest('form').submit()
  })

  const options = {
    currencySymbol: "$",
    currencySymbolPlacement: "p",
    decimalCharacter: ".",
    digitGroupSeparator: ",",
    negativePositiveSignPlacement: "r",
    unformatOnSubmit: true,
    modifyValueOnWheel: false
  }

  const renewalDateLabel = $(".subscription-renewal-date-label")
  const renewalDateField = $(".subscription-renewal-date-field")
  const recurringIntervalField = $(".subscription-recurring-interval-field")

  const isProject = function() {
    return recurringIntervalField.val() === 'project'
  }

  // when project is selected, sync all the products' valid until fields with the subscription top valid until
  const setupValidUntil = function() {
    if (isProject()) {
      $(".selected-price-field").hide()
      $(".valid-until-field").val(renewalDateField.val())

      renewalDateField.on('change', function() {
        if (isProject()) {
          $(".valid-until-field").val(renewalDateField.val())
        }
      })
    } else {
      $(".selected-price-field").show()
    }
  }

  setupValidUntil()

  function addMonths(numOfMonths, date = new Date()) {
    date.setMonth(date.getMonth() + numOfMonths);

    return date.toISOString().split('T')[0];
  }

  const reloadRenewalField = (onlyIfEmpty = false) => {
    if (onlyIfEmpty && renewalDateField.val() !== '') {
      return
    }

    const val = recurringIntervalField.val()

    if (val === 'month') {
      renewalDateField.val(addMonths(1))
    } else if (val === 'year') {
      renewalDateField.val(addMonths(12))
    }
  }

  recurringIntervalField.on('change', function() {
    const val = recurringIntervalField.val()
    if (val === 'project') {
      renewalDateLabel.html("Expiration Date")
      setupValidUntil()
    } else {
      reloadRenewalField()
      renewalDateLabel.html("Renewal Date")
    }
  })

  reloadRenewalField(true)

  $(".payment-amount-formatted").each((index, value) => {
    new AutoNumeric(value, options)
  })

  $('body')
    .on('cocoon:after-insert', function (e, addedElement) {

      addedElement.find(".payment-amount-formatted").each((index, value) => {
        new AutoNumeric(value, options)
      })

      addedElement.find("admin-subscription-prefill").each((index, value) => {
        new Vue({
          el: value
        })
      })

      setupValidUntil()
    })

  // The following are used to update the header in the admin/create subscription page

  const setPackageSum = function () {
    let total = 0;
    $('.subscription-operation-fields .subscription-product-image-count-field').each((index, el) => {
      const n = parseInt($(el).val(), 10)
      if (n > 0) {
        total += n
      }
    })
    $('.subscription-package-size-result').html(`${total} assets`)
  };

  const setPrice = function () {
    const val = $('.subscription-operation-fields .payment-amount-formatted').val()
    $('.subscription-package-price-result').html(val)
  }

  const setRenewalDate = function () {
    $('.subscription-package-renewal-result').html(renewalDateField.val())
  }

  $('.subscription-operation-fields').on('keyup wheel change', '.subscription-product-image-count-field', function () {
    setPackageSum()
  }).on('keyup change', '.payment-amount-formatted', function () {
    setPrice()
  })

  $('.subscription-renewal-date-field').on('change', function () {
    setRenewalDate()
  })

  setPackageSum()
  setPrice()
  setRenewalDate()

});